import { render, staticRenderFns } from "./KeyBoard.vue?vue&type=template&id=6a3973d0&scoped=true&"
import script from "./KeyBoard.vue?vue&type=script&lang=js&"
export * from "./KeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./KeyBoard.vue?vue&type=style&index=0&id=6a3973d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3973d0",
  null
  
)

export default component.exports